// frontend/src/components/DateRangeControls.js

import React from 'react';
import { Button, DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import './DateRangeControls.css';

const DEFAULT_PERIODS = ["1Y", "5Y", "10Y", "ALL"];

const DateRangeControls = ({
    minDate,
    maxDate,
    viewStartDate,
    viewEndDate,
    onPeriodChange,
    onDateChange,
    periods = DEFAULT_PERIODS,
    activePeriod
}) => {
    const disabledDate = (current) => {
        if (!minDate || !maxDate) return false;
        return current < dayjs(minDate) || current > dayjs(maxDate);
    };

    const onDateChangeWrapper = (type, date) => {
        if (date) {
            onDateChange(type, date.toDate());
        }
    };

    return (
        <div className="date-range-container">
            <Space className="period-buttons" size={[8, 16]} wrap>
                {periods.map(period => (
                    <Button 
                        key={period} 
                        onClick={() => onPeriodChange(period)} 
                        className={period === activePeriod ? 'active' : ''} 
                    >
                        {isNaN(parseInt(period.slice(0, -1))) ? period : `${parseInt(period.slice(0, -1))}${period.slice(-1)}`}
                    </Button>
                ))}
            </Space>
            
            <Space className="date-pickers" wrap>
                <DatePicker
                    value={viewStartDate ? dayjs(viewStartDate) : null}
                    onChange={(date) => onDateChangeWrapper('start', date)}
                    disabledDate={disabledDate}
                    allowClear={false}
                    format="YYYY-MM-DD" // 표시 형식 지정
                />
                <DatePicker
                    value={viewEndDate ? dayjs(viewEndDate) : null}
                    onChange={(date) => onDateChangeWrapper('end', date)}
                    disabledDate={disabledDate}
                    allowClear={false}
                    format="YYYY-MM-DD" // 표시 형식 지정
                />
            </Space>
        </div>
    );
};

export default DateRangeControls;